import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


export const FormPaper = styled(Paper)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      marginLeft: 0,
      marginRight: 0,
      padding: theme.spacing(1),
      boxSizing: 'border-box',
      borderRadius: 0,
      overflowX: 'hidden',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '440px',
    },
    [theme.breakpoints.up('md')]: {
      width: '780px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '990px',
    },
    padding: theme.spacing(3),
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    marginLeft: "auto",
    marginRight: "auto",

}));

export const AevTabs = styled(Tabs)(({ theme }) => ({
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: theme.daPalette.lightGrey.main,
    minHeight: 32,
    '& .MuiTabs-scrollButtons.Mui-disabled': {
        opacity: 0.25,
    }
}));

export const AevTab = styled(Tab)(({ theme }) => ({
    minHeight: 32,
    paddingTop: 8,
    paddingBottom: 8,
    '&:hover': {
      color: theme.daPalette.blue.main,
      opacity: 1,
    },
}));
